import { useState } from 'react';
import { FAQS } from '@/mocks/gossip';

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-8 text-center">
          <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
            <i className="ri-question-answer-line" aria-hidden="true" />
            理性吃瓜指南
          </span>
          <h2 className="text-2xl font-bold tracking-wide text-foreground-950 md:text-[1.7rem]">
            关于这些瓜，你常问的几个问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            我们怎么整理<b>婚内出轨事件</b>、标签含义与可信度说明，都在这里说清楚。
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  isOpen ? 'border-accent-300 bg-accent-50/40' : 'border-background-200/70 bg-background-100'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : idx)}
                  className="flex w-full cursor-pointer items-center gap-3 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-accent-500 text-sm font-black text-background-50">
                    {idx + 1}
                  </span>
                  <span className="flex-1 text-[15px] font-medium text-foreground-900">{f.q}</span>
                  <i
                    className={`text-xl text-accent-600 transition-transform ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}
                    aria-hidden="true"
                  />
                </button>
                {isOpen && (
                  <div className="border-t border-accent-200/60 px-5 pb-5 pt-3">
                    <p className="pl-10 text-sm leading-7 text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-8 flex flex-col items-center gap-3 rounded-xl border border-background-200/70 bg-gradient-to-br from-background-100 to-secondary-100 p-6 text-center sm:flex-row sm:justify-between sm:text-left">
          <div>
            <h3 className="font-heading text-xl font-bold text-foreground-950">没找到你想看的瓜？</h3>
            <p className="mt-1 text-sm text-foreground-600">留言告诉我们关键词，话题墙与时间线会持续收录补充。</p>
          </div>
          <div className="flex shrink-0 gap-2">
            <button
              type="button"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              投稿线索
            </button>
            <button
              type="button"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              反馈问题
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}